import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createRunSecondChanceCashflowAndAutoOriginationStrategyThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(
    ApplicationProcessActionTypes.RunSecondChanceCashflowAndAutoOrigination,
    async ({ applicationId }: { applicationId: string }) => {
      const response = await api.runSecondChanceCashflowAndAutoOriginationStrategy(applicationId);
      return response;
    },
  );
